import React, {Component} from "react"
import PropTypes from "prop-types"

export default class MultipleChoice extends Component {
  static propTypes = {
    question: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired
  }

  state = {checked: []}

  _handleChange(e) {
    const {question, onChange} = this.props
    const value = e.currentTarget.value

    const checked = [...this.state.checked]

    // remove or add value from checked array
    if (checked.includes(value)) {
      const index = checked.indexOf(value)

      checked.splice(index, 1)
    } else {
      checked.push(value)
    }

    // update state and trigger callback function afterwards
    this.setState(
      prevState => {
        return {...prevState, checked}
      },
      () => {
        // uuids must be prefixed with "question_"
        onChange({
          [`question_${question.id}`]: this.state.checked.join(", ")
        })
      }
    )
  }

  componentDidUpdate(prevProps) {
    // reset state if question changes but it's the same question type
    if (prevProps.question.id !== this.props.question.id) {
      this.setState(prevState => {
        return {...prevState, checked: []}
      })
    }
  }

  render() {
    const {question} = this.props

    return (
      <div className="multiple-choice">
        {question.multiple_choice.map(({answer}, index) => {
          return (
            <span key={`answer-${question.id}-${index}`}>
              <input
                id={`answer-${question.id}-${index}`}
                type="checkbox"
                name="answer"
                value={answer}
                onChange={e => this._handleChange(e)}
              />
              <label htmlFor={`answer-${question.id}-${index}`}>{answer}</label>
            </span>
          )
        })}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Feedback/MultipleChoice/index.js